export default __webpack_public_path__ + "e237404b26aa561de1a7ce1d6263fea8.png";